import { FilterGroup } from 'components/Filters/components/FilterModal'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { SEQUENCE_COLUMNS } from './sequenceColumnInfo'

const REPLY_STATUS_OPTIONS = [
  { value: 'no_reply', label: 'No Reply' },
  { value: 'replied', label: 'Replied (any)' },
  { value: 'replied_interested', label: 'Interested' },
  { value: 'replied_not_interested', label: 'Not Interested' },
  { value: 'replied_unclassified', label: 'Unclassified' },
]

const EMAIL_STATUS_OPTIONS = [
  { value: 'delivered', label: 'Delivered' },
  { value: 'bounced', label: 'Bounced' },
  { value: 'opened', label: 'Opened' },
  { value: 'not_opened', label: 'Not Opened' },
  { value: 'unsubscribed', label: 'Unsubscribed' },
]

const SEQUENCE_PROGRESS_OPTIONS = [
  { value: 'in_sequence', label: 'In Progress' },
  { value: 'sequence_finished', label: 'Completed' },
  { value: 'sequence_stopped', label: 'Stopped' },
  { value: 'not_in_sequence', label: 'Not in Sequence' },
]

interface Props {
  filterStore: ReturnType<any>
}

export function SequenceFilterGroup({ filterStore }: Props) {
  const filterHelper = createFilterColumnHelper({
    columns: SEQUENCE_COLUMNS,
  })

  return (
    <FilterGroup title="Email Sequence" className="lg:grid-cols-2">
      <SelectFilter
        {...filterHelper.retrieveProps('seq_reply_status')}
        filterKey="reply_status"
        title="Reply Status"
        options={REPLY_STATUS_OPTIONS}
        filterStore={filterStore}
      />
      <SelectFilter
        {...filterHelper.retrieveProps('seq_opened')}
        filterKey="email_status"
        title="Email Status"
        options={EMAIL_STATUS_OPTIONS}
        filterStore={filterStore}
      />
      <SelectFilter
        {...filterHelper.retrieveProps('seq_sequence_step')}
        filterKey="sequence_progress"
        title="Sequence Progress"
        options={SEQUENCE_PROGRESS_OPTIONS}
        filterStore={filterStore}
      />
    </FilterGroup>
  )
}
